import { useMemo } from 'react';
import { useData } from '../contexts/index';
import { useDataSync } from './useDataSync';
import {
  buildListerAgreement,
  buildRunnerAgreement,
} from '../core/rules/staffAgreements';
import { ROLES } from '../core/constants/roles';

import type { AppUser } from '../types';
import type { PlayLike } from '../core/rules/numberCaps';

type AgreementTarget = AppUser | { id?: string; role?: string; listerId?: string };

export function useStaffAgreementForUser(target: AgreementTarget | null | undefined) {
  const { adapter } = useData();
  const plays = useDataSync<PlayLike[]>(adapter, 'plays', []);
  const stops = useDataSync<Array<Record<string, unknown>>>(adapter, 'routeStops', []);

  return useMemo(() => {
    if (!target?.id || !target?.role) return null;
    if (target.role === ROLES.LISTER) {
      const listerPlays = plays.filter((p) => p.listerId === target.id);
      return buildListerAgreement(target as AppUser, target as AppUser, listerPlays);
    }
    if (target.role === ROLES.RUNNER) {
      return buildRunnerAgreement(target as AppUser, target as AppUser, stops as Parameters<typeof buildRunnerAgreement>[2]);
    }
    return null;
  }, [target, plays, stops]);
}
